import React, { memo } from 'react'
import PropTypes from 'prop-types'
import ItemBorder from '@v4/components/common/ItemBorder'
import Content from '../../../../components/Content'
import { useItem } from './Item.hooks'

const Item = props => {
	const [
		{ classes, text, textConfig, image, rounding, itemKey, group, textEditable, textKey },
		{ handleImageClick, handleTextClick, handleClick, handleTextChange },
	] = useItem(props)

	return (
		<ItemBorder itemKey={itemKey} group={group}>
			<Content
				text={text}
				textConfig={textConfig}
				textEditable={textEditable}
				image={image}
				classes={classes}
				rounding={rounding}
				className="testimonial4-item-content"
				onImageClick={handleImageClick}
				onTextClick={handleTextClick}
				onClick={handleClick}
				onTextChange={handleTextChange}
				textKey={textKey}
			/>
		</ItemBorder>
	)
}

Item.propTypes = {
	group: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired,
	itemKey: PropTypes.string.isRequired,
	rounding: PropTypes.number.isRequired,
	classes: PropTypes.shape({
		root: PropTypes.string,
		image: PropTypes.string,
	}).isRequired,
}
export default memo(Item)
